import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M16.9132 8.16354L10.6632 14.4135C10.5762 14.5009 10.4727 14.5703 10.3587 14.6176C10.2447 14.6649 10.1226 14.6893 9.99918 14.6893C9.8758 14.6893 9.75362 14.6649 9.63967 14.6176C9.52571 14.5703 9.42222 14.5009 9.33512 14.4135L3.08512 8.16354C2.909 7.98742 2.81006 7.74855 2.81006 7.49948C2.81006 7.25041 2.909 7.01154 3.08512 6.83542C3.26124 6.65929 3.50011 6.56035 3.74918 6.56035C3.99826 6.56035 4.23713 6.65929 4.41325 6.83542L9.99997 12.4221L15.5867 6.83463C15.7628 6.65851 16.0017 6.55957 16.2507 6.55957C16.4998 6.55957 16.7387 6.65851 16.9148 6.83463C17.0909 7.01075 17.1899 7.24963 17.1899 7.4987C17.1899 7.74777 17.0909 7.98664 16.9148 8.16276L16.9132 8.16354Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconChevronDown'

export const IconChevronDown = memo(themed(Icon))
